
export default function Battle({
  battle,
  children,
}: {
  battle: number;
  children: React.ReactNode;
}) {
  return (
    <div className="war-battle" data-id={battle}>
      <div className="war-battle__content">{children}</div>
    </div>
  );
}
